import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { Chat, ChatUpdates } from '../../types/chat.types';

@Injectable({
  providedIn: 'root',
})
export class ChatApiService {
  private readonly baseUrl = '/api/chat';
  private httpWithoutInterceptor: HttpClient;

  constructor(private http: HttpClient, private httpBackend: HttpBackend) {
    this.httpWithoutInterceptor = new HttpClient(httpBackend);
  }

  createChat(): Promise<Chat> {
    return firstValueFrom(this.http.post<Chat>(this.baseUrl, {}));
  }

  async getChatList(): Promise<[Chat[], boolean]> {
    try {
      const chats = await firstValueFrom(this.httpWithoutInterceptor.get<Chat[]>(this.baseUrl));
      return [chats, true];
    } catch {
      return [[], false];
    }
  }

  getChat(id: string): Promise<Chat> {
    return firstValueFrom(this.http.get<Chat>(`${this.baseUrl}/${id}`));
  }

  sendMessage(chatId: string, message: string): Promise<Chat> {
    return firstValueFrom(this.http.post<Chat>(`${this.baseUrl}/${chatId}/messages`, {
      message,
    }));
  }

  getUpdates(chatId: string, fromVersion: number, timeout = 30): Promise<ChatUpdates> {
    const url = `${this.baseUrl}/${chatId}/updates?from_version=${fromVersion}&timeout=${timeout}`;
    return firstValueFrom(this.http.get<ChatUpdates>(url));
  }

  getUpdates$(chatId: string, fromVersion: number, timeout = 30): Observable<ChatUpdates> {
    const url = `${this.baseUrl}/${chatId}/updates?from_version=${fromVersion}&timeout=${timeout}`;
    return this.http.get<ChatUpdates>(url);
  }
}
